import * as React from 'react'

const SvgGlobeOrangeIcon = (props) => (
  <svg
    width="56"
    height="57"
    viewBox="0 0 56 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4420_105249)">
      <rect x="12" y="0.549805" width="32" height="32" rx="8" fill="#FF692E" />
      <path
        d="M21.7744 20.7762L24.837 17.7136M32.1453 10.4053C34.6186 12.8786 34.6186 16.8886 32.1453 19.362C29.672 21.8353 25.6619 21.8353 23.1886 19.362M31.3336 23.2169H24.667M28.0003 23.2169V21.2169M31.667 14.8836C31.667 17.0928 29.8761 18.8836 27.667 18.8836C25.4578 18.8836 23.667 17.0928 23.667 14.8836C23.667 12.6745 25.4578 10.8836 27.667 10.8836C29.8761 10.8836 31.667 12.6745 31.667 14.8836Z"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_4420_105249"
        x="0"
        y="0.549805"
        width="56"
        height="56"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="12"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_4420_105249"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.411765 0 0 0 0 0.180392 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4420_105249"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4420_105249"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export default SvgGlobeOrangeIcon
